import { useId } from 'react'

import { Switch } from '@gto/ui/switch'
import { Typography } from '@gto/ui/typography'

export type CouponSwitchRowProps = {
  checked: boolean
  label: string
  description: string
  onCheckedChange: (checked: boolean) => void
}

export const CouponSwitchRow = ({
  checked,
  label,
  description,
  onCheckedChange,
}: CouponSwitchRowProps) => {
  const switchId = useId()
  const descriptionId = useId()

  return (
    <div className="flex flex-row items-start justify-between gap-3">
      <div className="flex min-w-0 flex-1 flex-col">
        <label
          className="cursor-pointer"
          htmlFor={switchId}
        >
          <Typography
            component="span"
            variant="body2"
          >
            {label}
          </Typography>
        </label>
        <Typography
          color="text.secondary"
          id={descriptionId}
          variant="caption"
        >
          {description}
        </Typography>
      </div>
      <Switch
        aria-describedby={descriptionId}
        checked={checked}
        className="shrink-0"
        id={switchId}
        onCheckedChange={onCheckedChange}
      />
    </div>
  )
}
